import { LiveChatEndReason } from '../app/types/enum';

export function getEndOfChatTextKey(reason: LiveChatEndReason): string {
  switch (reason) {
    case LiveChatEndReason.USER_CANCELED:
      return 'CHAT.USER_CANCEL_CHAT';
    case LiveChatEndReason.USER_ENDED:
      return 'CHAT.USER_CLOSE_CHAT';
    case LiveChatEndReason.OPERATOR_ENDED:
      return 'CHAT.AGENT_CLOSE_CHAT';
    default:
      return '';
  }
}
